const BaseComponent = require( 'common/home/view' );
const Server = require( 'helper/server' );

class FloatingWindow extends BaseComponent {
  constructor() {
    super();
    this.init();
  }


  init() {
    $("#floatingWindow").hide();
    $('#floatingWindow-close').click(function () {
      $('#floatingWindow').hide();
    });
    this.showFloat();
  }
  async showFloat () {
    const res = await Server.queryFloating();
    const { floatingType, floatingPicture, description, url} = res;
    let str = "";
    // console.log('==', res, floatingType);
    if (floatingType){
      $("#floatingWindow").show();
      if ( floatingType === 2){
        str = url ? `<a href="${url}"><p>${description}</p></a>` : `<p>${description}</p>`;
      } else {
        str = url ? `<a href="${url}"><img src="${floatingPicture}"/></a>` : `<img src="${floatingPicture}"/>`;
      }
      $("#floatingWindow-content").html(str);
    }
  }
}

module.exports = FloatingWindow;
